module.exports = __webpack_public_path__ + "img/landing-btn-services-icon.9d36fa6a.svg";